import axios from "axios";
import store from "@/store";

axios.interceptors.request.use(async function(config) {
  if (
    store.getters["auth/rememberMe"] && // have tools for refresh token
    store.getters["auth/expiredAt"] < new Date() && // session is expired
    config.url.indexOf("/online_accounts/refresh_token.json") === -1 // not in refresh token route
  ) {
    await store.dispatch("auth/refresh"); // refresh token
    config.headers.authorization = `Bearer ${store.getters["auth/getToken"]}`;
    return config;
  } else {
    return config;
  }
});

axios.interceptors.response.use(
  response => response,
  async function(error) {
    // redirect to home page if user is not authorized
    if (error.response.status === 401) {
      await store.dispatch("auth/logout");
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);
